/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AssetImportResultDto } from './AssetImportResultDto';

export type ExternalCatalogImportResultDto = {
    importStatus?: ExternalCatalogImportResultDto.importStatus;
    results?: Array<AssetImportResultDto>;
};

export namespace ExternalCatalogImportResultDto {

    export enum importStatus {
        SUCCESS = 'SUCCESS',
        PARTIAL_SUCCESS = 'PARTIAL_SUCCESS',
        FAILURE = 'FAILURE',
    }


}
